/* ==========================================================================
   Split Headings
   ========================================================================== */

// ...

import gsap from "gsap";
import SplitText from "gsap/SplitText";

function splitHeadings() {
  gsap.registerPlugin(SplitText);
  gsap.config({ nullTargetWarn: false });
  const splitchild = new SplitText(".hd-split", {
    type: "lines",
    linesClass: "split-child",
  });
  const splitHeading = new SplitText(".hd-split", {
    linesClass: "split-heading",
    type: "lines",
  });
}

window.addEventListener("load", function () {
  splitHeadings();
});
